const map = {
	"./invitation.js": 9639,
	"./invoice.js": 32537,
	"./order.js": 38866,
	"./project-item.js": 9771,
	"./project.js": 57147,
	"./sales-order.js": 1199,
	"./session.js": 89754,
	"./transaction.js": 74850,
	"utils/api/queries/invitation.js": 9639,
	"utils/api/queries/invoice.js": 32537,
	"utils/api/queries/order.js": 38866,
	"utils/api/queries/project-item.js": 9771,
	"utils/api/queries/project.js": 57147,
	"utils/api/queries/sales-order.js": 1199,
	"utils/api/queries/session.js": 89754,
	"utils/api/queries/transaction.js": 74850
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99070;